var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h6", [_vm._v("■職種設定")]),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: _vm.offerPointTitle } },
        [
          !_vm.isCompanyStaffAccess
            ? _c(
                "job-content-table-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "給与コード",
                      "target-id":
                        _vm.targetIdMap.categorySetting.point.salaryCode,
                      value: _vm.jobCategorySettings.offerPoint.salary,
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.categorySetting.point.salaryCode
                      ),
                      "highlight-mode": _vm.highlightMode,
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "職種[1]",
                  "target-id":
                    _vm.targetIdMap.categorySetting.point.jobName + "-1",
                  value: _vm.jobCategorySettings.offerPoint.jobName1,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.point.jobName + "-1"
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "職種[2]",
                  "target-id":
                    _vm.targetIdMap.categorySetting.point.jobName + "-2",
                  value: _vm.jobCategorySettings.offerPoint.jobName2,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.point.jobName + "-2"
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          !_vm.isCompanyStaffAccess
            ? _c(
                "job-content-table-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "対象学歴",
                      "target-id":
                        _vm.targetIdMap.categorySetting.point.education,
                      value: _vm.jobCategorySettings.offerPoint.educationTarget,
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.categorySetting.point.education
                      ),
                      "highlight-mode": _vm.highlightMode,
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCompanyStaffAccess
            ? _c(
                "job-content-table-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "年齢",
                      "target-id": _vm.targetIdMap.categorySetting.point.age,
                      value: _vm.jobCategorySettings.offerPoint.ageFromTo,
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.categorySetting.point.age
                      ),
                      "highlight-mode": _vm.highlightMode,
                    },
                  },
                  _vm.$listeners
                ),
                [
                  _c("br"),
                  _vm._v(" "),
                  _c("a", { on: { click: _vm.openBossSAgeRegulation } }, [
                    _vm._v("［PDF］年齢制限の禁止について"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCompanyStaffAccess
            ? _c(
                "job-content-table-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "年収",
                      "target-id": _vm.targetIdMap.categorySetting.point.salary,
                      value:
                        _vm.jobCategorySettings.offerPoint.annualIncomeFromTo,
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.categorySetting.point.salary
                      ),
                      "highlight-mode": _vm.highlightMode,
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "外部表示用職種名",
                  "target-id":
                    _vm.targetIdMap.categorySetting.point.externalJobName,
                  value: _vm.jobCategorySettings.offerPoint.externalJobName,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.point.externalJobName
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "会社について" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "正式社名",
                  "target-id": _vm.targetIdMap.categorySetting.about.formalName,
                  value: _vm.jobCategorySettings.aboutCompany.formalName,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.about.formalName
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            ),
            [
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "notice" }, [
                _vm._v("※支店名、事業部名、グループ名等の入力不可。"),
              ]),
              _vm._v(" "),
              _vm.jobCategorySettings.aboutCompany.isVisibleInGoogle
                ? _c(
                    "span",
                    {
                      staticClass: "notice",
                      attrs: { "data-test": "isVisibility" },
                    },
                    [_vm._v("※提携サイト掲載時にこちらの社名が使用されます。")]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "表示用社名",
                  "target-id":
                    _vm.targetIdMap.categorySetting.about.displayName,
                  value: _vm.jobCategorySettings.aboutCompany.displayName,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.about.displayName
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            ),
            [
              _c("br"),
              _vm._v(" "),
              !_vm.jobCategorySettings.aboutCompany.isVisibleInGoogle
                ? _c("span", { staticClass: "notice" }, [
                    _vm._v("※提携サイト掲載時にこちらの社名が使用されます。"),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "業種名",
                  "target-id":
                    _vm.targetIdMap.categorySetting.about.businessName,
                  value: _vm.jobCategorySettings.aboutCompany.businessName,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.about.businessName
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("job-content-table", {
        attrs: { title: "設定済PRコード一覧" },
        scopedSlots: _vm._u(
          [
            !_vm.isCompanyStaffAccess
              ? {
                  key: "title",
                  fn: function () {
                    return [
                      _vm._v("\n      ("),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openBossSPRCodes()
                            },
                          },
                        },
                        [_vm._v("すべてのPRコード")]
                      ),
                      _vm._v(")\n    "),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "job-content-table-outline",
                    _vm._g(
                      {
                        attrs: {
                          title: "アピールポイント",
                          "target-id":
                            _vm.targetIdMap.categorySetting.pr.normal,
                          value:
                            _vm.jobCategorySettings.configuredPrContents
                              .normalPrContents,
                          "comment-highlights": _vm.getCommentHighlights(
                            _vm.targetIdMap.categorySetting.pr.normal
                          ),
                          "highlight-mode": _vm.highlightMode,
                        },
                      },
                      _vm.$listeners
                    )
                  ),
                  _vm._v(" "),
                  _c(
                    "job-content-table-outline",
                    _vm._g(
                      {
                        attrs: {
                          title: "特集用検索コード",
                          "target-id": _vm.targetIdMap.categorySetting.pr.ura,
                          value:
                            _vm.jobCategorySettings.configuredPrContents
                              .uraPrContents,
                          "comment-highlights": _vm.getCommentHighlights(
                            _vm.targetIdMap.categorySetting.pr.ura
                          ),
                          "highlight-mode": _vm.highlightMode,
                        },
                      },
                      _vm.$listeners
                    )
                  ),
                  _vm._v(" "),
                  _c(
                    "job-content-table-outline",
                    _vm._g(
                      {
                        attrs: {
                          title: "エンジニア系特集用検索コード",
                          "target-id":
                            _vm.targetIdMap.categorySetting.pr.uraEngineer,
                          value:
                            _vm.jobCategorySettings.configuredPrContents
                              .uraEngineerPrContents,
                          "comment-highlights": _vm.getCommentHighlights(
                            _vm.targetIdMap.categorySetting.pr.uraEngineer
                          ),
                          "highlight-mode": _vm.highlightMode,
                        },
                      },
                      _vm.$listeners
                    )
                  ),
                  _vm._v(" "),
                  _c(
                    "job-content-table-outline",
                    _vm._g(
                      {
                        attrs: {
                          title: "サービス・販売系特集用検索コード",
                          "target-id":
                            _vm.targetIdMap.categorySetting.pr.uraService,
                          value:
                            _vm.jobCategorySettings.configuredPrContents
                              .uraServicePrContents,
                          "comment-highlights": _vm.getCommentHighlights(
                            _vm.targetIdMap.categorySetting.pr.uraService
                          ),
                          "highlight-mode": _vm.highlightMode,
                        },
                      },
                      _vm.$listeners
                    )
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "専用応募フォーム" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "設定URL",
                  "target-id": _vm.targetIdMap.categorySetting.applyUrl,
                  value: _vm.jobCategorySettings.applyUrl,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.applyUrl
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
                scopedSlots: _vm._u(
                  [
                    _vm.jobCategorySettings.applyUrl
                      ? {
                          key: "body",
                          fn: function () {
                            return [
                              _c(_vm.tag, {
                                tag: "component",
                                staticClass: "pega-break text-underline",
                                class: {
                                  "pega-anchor-text": _vm.highlightMode,
                                },
                                attrs: {
                                  id: _vm.targetIdMap.categorySetting.applyUrl,
                                  href: _vm.jobCategorySettings.applyUrl,
                                  rel: "nofollow",
                                  target: "blank",
                                  "data-test": "value",
                                },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.jobCategorySettings.applyUrl
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: _vm.questionTitle } },
        _vm._l([1, 2, 3], function (index) {
          return _c(
            "job-content-table-outline",
            _vm._g(
              {
                key: "question-" + index,
                attrs: {
                  title: "独自質問" + index,
                  "target-id":
                    _vm.targetIdMap.categorySetting.question + "-" + index,
                  value: _vm.questionItems["question" + index],
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.question + "-" + index
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "情報提供" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "外部連携データ",
                  "target-id": _vm.targetIdMap.categorySetting.provided,
                  value: _vm.jobCategorySettings.providedInfo,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.categorySetting.provided
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }